var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncludedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2181_6666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 3.01556C19.9521 3.07289 19.9021 3.12678 19.8568 3.18756C15.5859 8.84489 11.3151 14.5031 7.04425 20.1623C6.98492 20.2418 6.93492 20.3329 6.82867 20.5C6.76717 20.3702 6.7365 20.2693 6.68283 20.1976C4.5099 17.3083 2.33576 14.4208 0.160417 11.5348C0.108333 11.4656 0.0536667 11.4139 0 11.3539V11.3021L1.66667 9.09222C1.72359 9.00831 1.77698 8.92025 1.82658 8.82845L6.83017 15.4631L18.0802 0.5C18.5136 1.06489 18.9135 1.59178 19.3197 2.11444C19.5422 2.40178 19.7698 2.68278 19.9968 2.96667L20 3.01556Z",
    fill: "#10A37F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2181_6666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludedIcon);
export default __webpack_public_path__ + "static/media/includedIcon.7300c4e0fe83b0b0026295069a631512.svg";
export { ForwardRef as ReactComponent };